import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { alpha } from '@mui/material/styles';
import OpenInNewRounded from '@mui/icons-material/OpenInNewRounded';
import { useTranslation } from 'react-i18next';

import { Section, SectionHeading } from './Section';
import Reveal from './Reveal';
import { azure, glassHover } from '../theme';

import imgPertemps from '../assets/img/imgpng.png';
import imgDefra from '../assets/img/imgdefra.png';
import imgNhs from '../assets/img/imgnhs.png';
import imgIcl from '../assets/img/imgicl.png';
import imgDijlah from '../assets/img/imgdv.png';

const CLIENTS = [
  { key: 4, image: imgNhs, href: 'https://www.england.nhs.uk/' },
  { key: 2, image: imgDefra, href: 'https://www.gov.uk/government/organisations/department-for-environment-food-rural-affairs' },
  { key: 3, image: imgIcl, href: 'https://www.imperial.ac.uk/' },
  { key: 1, image: imgPertemps, href: 'https://www.pertemps.co.uk/' },
  { key: 5, image: imgDijlah, href: 'https://dijlahvillage.com/' },
];

export default function OurClients() {
  const { t } = useTranslation();

  return (
    <Section id="clients" sx={{ bgcolor: alpha('#FFFFFF', 0.014) }}>
      <SectionHeading
        eyebrow={t('clientsSection.eyebrow')}
        title={t('clientsSection.title')}
        lead={t('clientsSection.lead')}
      />

      <Box
        sx={{
          display: 'grid',
          gap: 3,
          gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' },
        }}
      >
        {CLIENTS.map(({ key, image, href }, i) => (
          <Reveal key={key} delay={i * 90} sx={{ display: 'flex' }}>
            <Card
              sx={{
                p: 3,
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                transition: 'all .3s cubic-bezier(.2,.8,.2,1)',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  borderColor: alpha(azure[300], 0.4),
                  backgroundColor: glassHover,
                },
              }}
            >
              <Box
                sx={{
                  height: 110,
                  borderRadius: 3,
                  mb: 2.5,
                  display: 'grid',
                  placeItems: 'center',
                  bgcolor: 'rgba(255,255,255,0.94)',
                  p: 2,
                }}
              >
                <Box
                  component="img"
                  src={image}
                  alt={t(`clients.subtitlelink${key}`)}
                  loading="lazy"
                  sx={{ width: '100%', height: '100%', minWidth: 0, minHeight: 0, objectFit: 'contain' }}
                />
              </Box>
              <Link
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 0.75,
                  color: 'text.primary',
                  fontWeight: 700,
                  fontSize: '1.05rem',
                  mb: 1,
                  '&:hover': { color: azure[300] },
                }}
              >
                {t(`clients.subtitlelink${key}`)}
                <OpenInNewRounded sx={{ fontSize: 15, color: 'text.secondary' }} />
              </Link>
              <Typography variant="body2" color="text.secondary">
                {t(`clients.subtitle${key}`)}
              </Typography>
            </Card>
          </Reveal>
        ))}
      </Box>
    </Section>
  );
}
